import { render, staticRenderFns } from "./GeneralInformationForm.vue?vue&type=template&id=601829a8&scoped=true&"
import script from "./GeneralInformationForm.vue?vue&type=script&lang=ts&"
export * from "./GeneralInformationForm.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInformationForm.vue?vue&type=style&index=0&id=601829a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601829a8",
  null
  
)

export default component.exports